import type { Params } from 'react-router-dom'

import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import moment from 'moment'
import type { $Values } from 'utility-types'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import View, { DEFAULT_GROUP_TYPE } from 'modules/shift_management/store/internal/models/View'
import type { GROUP_TYPES, VIEW_TYPES } from 'modules/shift_management/store/internal/models/View'

type ParamProps = Readonly<Params<string>>
type ViewTypes = $Values<typeof VIEW_TYPES>
type GroupTypes = $Values<typeof GROUP_TYPES>

export const useCustomViewGroupPath = (params: ParamProps) => {
  const { navigation } = useNavigation()

  const { year, month, day, viewType: viewTypeParams, groupType: groupTypeParams } = params
  const dateFromParams = moment([Number(year), Number(month) - 1, Number(day)])
  const date = dateFromParams.isValid() ? dateFromParams : moment()

  const localStorageKey = LOCAL_STORAGE_KEYS.shiftManagementView
  const [localStorage] = useLocalStorage<string>(localStorageKey)
  const localStorageViewType = localStorage?.split('/')[0]
  const localStorageGroupType = localStorage?.split('/')[1]

  const viewType = (viewTypeParams || localStorageViewType) as ViewTypes
  const groupType = (groupTypeParams || localStorageGroupType || DEFAULT_GROUP_TYPE) as GroupTypes

  const view = new View({
    date,
    viewType: viewType,
    groupType: groupType,
  })

  return navigation.shifts.customViewGroup.fullPath({
    viewType: view.viewType,
    groupType: view.groupType,
    year: view.startRangeYear,
    month: view.startRangeMonth,
    day: view.startRangeDay,
  })
}
